import React from "react";
import "./styles.css";
const ButtonWhatsApp = () => {
  return (
    <a
      href="https://wa.me/50433537895?text=Hola,%20quiero%20realizar%20una%20compra%20en%20la%20página%20web%20y%20tengo%20una%20consulta.%20"
      target="blank"
      className="button-whatsApp"
    >
      <img
        src={"/assets/icons/icon-whatsapp.png"}
        className="button-whatsApp-icon"
        alt="icon-whatsapp"
      />
    </a>
  );
};

export default ButtonWhatsApp;
